<template>
    <div>
        <!-- 출결승인 팝업 -->
        <div v-show='isShowConfirm' class='layer-pop square-type'>
            <div class='view-content w650'>
                <button class='close' @click='onClickBtnCancel'><span class='blind'>팝업 닫기</span></button>
                <div class='scroll-area com-scroll-y'>
                    <span class='sub-title'>출결승인</span>
                    <div class='attend-info-area'>
                        <span class='top-user'>
                            <strong>{{ centerCustomerName }}</strong> 회원님
                            <span v-if="lessonType === 'P'" class='ico type-1'>[개인]</span>
                            <span v-else-if="lessonType === 'G'" class='ico type-2'>[그룹]</span>
                            <span v-else-if="lessonType === 'D'" class='ico type-5'>[듀엣]</span>
                            <span v-else-if="lessonType === 'O'" class='ico type-6'>[OT]</span>
                            <!--
                            <span class="ico type-3">[패키지]</span>
                            <span class="ico type-4">[회원권]</span>
                            -->
                            {{ lessonName }} : {{ lessonJoinCount }}/{{ lessonCount }}회
                        </span>
                        <div class='info-box'>
                            <span class='time'>{{ lessonDate }} {{ lessonStartTime }} ({{ teacherName }} 강사)</span>
                            <div class='input-line'>
                                <input v-model='scheduleCancelReason' class='w100p' placeholder='결석일 경우, 사유를 입력해주세요.'
                                       type='text'>
                            </div>
                        </div>
                    </div>
                    <div class='bottom-btn'>
                        <button :disabled='isButtonDisabled' class='com-btn blue' @keydown.enter.prevent @click='onClickBtnAttendance'>출석처리</button>
                        <button :disabled='isButtonDisabled' class='com-btn red' @keydown.enter.prevent @click='onClickBtnAbsence'>결석처리</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 출결승인 완료 팝업 -->
        <div v-show='isShowComplete' class='layer-pop square-type'>
            <div class='view-content w650'>
                <button class='close' @click='onClickBtnSuccess'><span class='blind'>팝업 닫기</span></button>
                <div class='scroll-area com-scroll-y'>
                    <span class='sub-title'>출결승인</span>
                    <div class='attend-info-area'>
                        <span class='top-user'><strong>{{ centerCustomerName }}</strong> 회원님</span>
                        <div class='info-box'>
                            <span class='time'>{{ getNowDatetime() }} </span>
                            <span v-if='processMode === status.absence' class='txt'><span class='red'>결석처리</span> 되었습니다.</span>
                            <span v-else-if='processMode === status.attendance' class='txt'><span
                                class='blue'>출석처리</span> 되었습니다.</span>
                        </div>
                    </div>
                    <div class='bottom-btn'>
                        <!--                      <button class="com-btn" @click="attendPop = false">취소</button>-->
                        <button class='com-btn blue' @click='onClickBtnSuccess'>확인</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';

export default {
    name: 'AttendanceApprovalDlg',
    props: {
        callbackSuccess: Function,
        callbackCancel: Function,
        callbackFail: Function,
    },
    computed: {
        isShowConfirm() {
            return this.isShow && this.isConfirmStep;
        },
        isShowComplete() {
            return this.isShow && !this.isConfirmStep;
        },
    },
    data() {
        return {
            isButtonDisabled: false,
            isShow: false,
            isConfirmStep: true,
            processMode: '',
            centerCustomerName: '박지현',
            lessonType: 'D',
            lessonName: '필라테스',
            lessonJoinCount: 2,
            lessonCount: 10,
            lessonDate: '2020-12-15',
            lessonStartTime: '13:00',
            teacherName: '김윤경',
            centerId: '',
            centerCustomerId: '',
            centerLessonScheduleId: '',
            joinSeq: '',
            scheduleCancelReason: '',
            status: {
                attendance: 'O',
                absence: 'X',
            },
        };
    },
    methods: {
        onClickBtnSuccess() {
            this.hide();
            if (!Utils.isEmpty(this.callbackSuccess)) {
                this.callbackSuccess();
            }
        },
        onClickBtnCancel() {
            this.hide();
            if (!Utils.isEmpty(this.callbackCancel)) {
                this.callbackCancel();
            }
        },
        async onClickBtnAttendance() {
            this.processMode = this.status.attendance;
            this.isButtonDisabled = true;

            try {
                await this.putLessonScheduleCustomerAttendanceStatus(this.status.attendance);
                this.isConfirmStep = false;
                this.isButtonDisabled = false;
                this.scheduleCancelReason = '';
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
                console.log(e);
                this.isButtonDisabled = false;
            }
        },
        async onClickBtnAbsence() {
            if (Utils.isEmpty(this.scheduleCancelReason)) {
                alert('사유를 입력해주세요.');
                return false;
            }

            this.processMode = this.status.absence;
            this.isButtonDisabled = true;

            try {
                await this.putLessonScheduleCustomerAttendanceStatus(this.status.absence, this.scheduleCancelReason);
                this.isConfirmStep = false;
                this.isButtonDisabled = false;
                this.scheduleCancelReason = '';
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
                this.isButtonDisabled = false;
                console.log(e);
            }
        },
        show() {
            this.isShow = true;
        },
        hide() {
            this.isShow = false;
            this.resetData();
        },
        resetData() {
            this.isConfirmStep = true;
        },
        async setLessonScheduleData(centerId, centerCustomerId, centerLessonScheduleId, lessonData) {
            this.centerId = centerId;
            this.centerCustomerId = centerCustomerId;
            this.centerLessonScheduleId = centerLessonScheduleId;

            try {
                const { data } = await this.getLessonScheduleCustomerContract(
                    this.centerId,
                    this.centerCustomerId,
                    this.centerLessonScheduleId,
                );

                this.centerCustomerName = data.centerCustomerName;
                this.lessonType = data.centerProduct.ticketType;
                this.lessonName = data.centerProduct.name;
                this.joinSeq = data.joinSeq;

                this.lessonJoinCount = Utils.isEmpty(lessonData.lessonJoinCount) ? 0 : lessonData.lessonJoinCount;
                this.lessonCount = lessonData.lessonCount;
                this.lessonDate = lessonData.lessonDate;
                this.lessonStartTime = lessonData.lessonStartTime;
                this.teacherName = lessonData.teacherName;
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        getLessonScheduleCustomerContract(centerId, centerCustomerId, centerLessonScheduleId) {
            const params = {
                centerLessonScheduleId,
            };
            return api.get(`/admin/api/center/${centerId}/lesson/schedule/daily/customer/${centerCustomerId}/contract`, { params });
        },
        putLessonScheduleCustomerAttendanceStatus(attendanceStatus, scheduleCancelReason = '') {
            const {
                centerId, joinSeq, centerCustomerId, centerLessonScheduleId,
            } = this;

            if (attendanceStatus == 'X' && this.lessonType == 'G') {
                // 스웨거 검색: 그룹레슨 결석처리
                return api.put(`/admin/api/center/${centerId}/lesson/schedule/groupLessonAbsent/customers`, {
                    centerId,
                    centerLessonScheduleId,
                    attendanceDevice: 'AW',
                    centerCustomerIds: [centerCustomerId],
                    lessonCustomerOffReason: scheduleCancelReason,
                });
            } else if (attendanceStatus == 'X' && this.lessonType != 'G') {
                // 스웨거 검색: 비 그룹레슨 결석처리
                return api.put(`/admin/api/center/${centerId}/lesson/schedule/absence-status`, {
                    centerLessonScheduleId,
                    attendanceDevice: 'AW',
                    centerCustomerIds: [centerCustomerId],
                    lessonCustomerOffReason: scheduleCancelReason,
                });
            }
            const params = {
                joinSeq,
                attendanceStatus,
                attendanceDevice: 'AW',
                scheduleCancelReason,
            };

            return api.put(`/admin/api/center/${centerId}/lesson/schedule/${centerLessonScheduleId}/customer/${centerCustomerId}/attendance-status`, params);
        },
        getNowDatetime() {
            return moment().format('YYYY-MM-DD HH:mm');
        },
    },
};
</script>

<style scoped>

</style>
